const TableRow = ({ children }) => {
    return  (
        <tr className="main-list__table-row">
            {children}
        </tr>
    );
};

export default TableRow;
